module.exports = __webpack_public_path__ + "img/card_giftcard_black_24dp.161076dc.svg";